<div class="container-fluid pb-3 mt-4 px-0 game-details" *ngIf="!isCxone; else cxoneSummaryModal">
	<button type="button" class="close" data-dismiss="dialog" (click)="close()">
		<span aria-hidden="true">&times;</span>
		<span class="sr-only" cvLocalizedText langSection="Common" langKey="Close">Close</span>
	</button>

	<!-- Header Game -->
	<div class="mt-4">
		<div class="d-flex flex-row justify-content-start">
			<div class="col-2 p-0 {{game.iconClass}}" style="min-width: 40px; width: 40px; height: 40px; background-size: 40px; background-repeat: no-repeat; background-position: center;"></div>
			<div class="d-flex flex-column pl-2 col-10">
				<div class="font-size-14 text-truncate text-left color-whaleTail">{{ gameName }}</div>
				<div class="font-size-12 text-left color-valyrianSteel">{{game.gameTypeName}}</div>
			</div>
		</div>
	</div>
	<!-- Game Information -->
	<div class="d-flex justify-content-between flex-column">
		<div class="color-whaleTail pt-2 pb-2 font-size-14" [ngSwitch]="game.underlyingRule.GameType">
			<span id="desc_MM" *ngSwitchCase="1" cvLocalizedText langSection="Games_History" langKey="DescMM">Commission style game; players rewarded per KPI unit achieved. Should only be used for count-type metrics.</span>
			<span id="desc_TD" *ngSwitchCase="2" cvLocalizedText langSection="Games_History" langKey="DescTD">Players rewarded according to how they rank against other players.</span>
			<span id="desc_BE" *ngSwitchCase="3" cvLocalizedText langSection="Games_History" langKey="DescBE">Players rewarded according to where they hit on the target (bullseye and rings).</span>
			<span id="desc_C3" *ngSwitchCase="6" cvLocalizedText langSection="Games_History" langKey="DescC3">Earn reward by connecting 3 metrics in a row. Horizontal, vertical, or diagonal connections count.</span>
      <span id="desc_TT" *ngSwitchCase="8" cvLocalizedText langSection="Games_History" langKey="DescTT">"Teams" win rewards according to where they rank in comparinson with other teams.</span>
      <span id="desc_RR" *ngSwitchCase="9" cvLocalizedText langSection="Games_History" langKey="DescRR">Prize(s) will be given out to a random qualified Participant.</span>
		</div>
	</div>
	<!-- Game Information -->
	<div class="d-flex justify-content-between">
		<div class="pt-3 pb-3 w-100 d-flex border-top border-bottom flex-column">
			<div class="d-flex flex-row color-valyrianSteel font-size-14">
				<div class="w-25" *ngIf="!isConnectGame">
                    <span class="pr-1" cvLocalizedText langSection="Objectives" langKey="Metric">Metric:</span>
				</div>
				<div class="w-75"><span class="r-1" cvLocalizedText langSection="Rules_Engine" langKey="Qualifier">Qualifier</span><span>:</span></div>
			</div>
			<div class="d-flex flex-row">
				<div class="w-25 text-break" *ngIf="!isConnectGame"><span class="color-whaleTail font-size-16 lato-bold">{{ singleMetricName }}</span></div>
				<div class="w-25 text-break"><span class="color-whaleTail font-size-16 lato-bold">{{ qualifierName }}</span></div>
				<div *ngIf="isValidQualifier" class="border-left pl-1" [ngSwitch]="qualifierMetric?.ComparerType">
                    <span *ngSwitchCase="1" class="color-whaleTail font-size-12">{{getLocalizedText("Greater_Than", "Greather Than") + " " +  getFormattedMetric(qualifierMetric.LeftNumber, qualifierMetric.MetricDetail?.ConversionType?.toString())}}</span>
                    <span *ngSwitchCase="2" class="color-whaleTail font-size-12">{{getLocalizedText("Less_Than", "Less Than") + " " + getFormattedMetric(qualifierMetric.RightNumber, qualifierMetric.MetricDetail?.ConversionType?.toString())}}</span>
                    <span *ngSwitchCase="3" class="color-whaleTail font-size-12">{{getLocalizedText("Between", "Between") + " " + getFormattedMetric(qualifierMetric.LeftNumber, qualifierMetric.MetricDetail?.ConversionType?.toString()) + " " + getLocalizedText("And", "And") + " " + getFormattedMetric(qualifierMetric.RightNumber, qualifierMetric.MetricDetail?.ConversionType?.toString())}}</span>
                </div>
			</div>
            
            <!-- Second line -->
            <div class="d-flex flex-row color-valyrianSteel font-size-14" *ngIf="gameData.underlyingRule.GameType == 10">
                <div class="w-50">
                    <span class="pr-1" cvLocalizedText langSection="Games" langKey="Players">Players</span><!--Translate-->
				</div>
            </div>
            <div class="d-flex flex-row" *ngIf="gameData.underlyingRule.GameType == 10">
				<div class="w-50 text-break" *ngIf="gameData.underlyingRule.GameType == 10">
                    <span class="color-whaleTail font-size-16 lato-bold">{{getBracketTournamentPlayers(gameData.BracketTournamentDetails.NumberOfRounds)}}</span>
                </div>
			</div>

            <!-- Third line -->
            <div class="d-flex flex-row color-valyrianSteel font-size-14" *ngIf="gameData.underlyingRule.GameType == 10">
				<div class="w-50">
                    <span class="pr-1" cvLocalizedText langSection="Games" langKey="Total_Matches">Total matches</span>
				</div>
				<div class="w-50"><span class="r-1" cvLocalizedText langSection="Games" langKey="Total_Rounds">Total Rounds</span></div>
			</div>
			<div class="d-flex flex-row" *ngIf="gameData.underlyingRule.GameType == 10">
				<div class="w-50 text-break"><span class="color-whaleTail font-size-16 lato-bold">{{getBracketTournamentMatches(gameData.BracketTournamentDetails.NumberOfRounds)}}</span></div>
				<div class="w-50 text-break"><span class="color-whaleTail font-size-16 lato-bold">{{gameData.BracketTournamentDetails.NumberOfRounds}}</span></div>
			</div>
		</div>
	</div>

	<!-- Connect3 - Display Metrics -->
	<div class="row p-2"  *ngIf="isConnectGame">
        <div class="col-4" *ngFor="let metricPosition of connect3Metrics">
            <div class="card p-2 mx-n2 my-2 text-center font-size-18" 
                [ngClass]="getConnect3Class(metricPosition)" style="height:100px">
                <div *ngIf="getCheck(metricPosition?.Position)" class="d-flex flex-row-reverse ">
                    <div class="icon-16 checkMarkConnect3"></div>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center h-100">
                    <div class="metric-container">
                        <div *ngIf="metricPosition === null"><svg class="icon-16 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg></div>
                        <div class="font-size-14">{{(metricPosition ===  null ? getLocalizedText("Metric_Goal", "Metric Goal") : (getLocalizedText(metricPosition.MetricDetail?.Abbrev.replace(" ", "_"), metricPosition.MetricDetail?.Abbrev)))}}</div>
                        <div *ngIf="metricPosition.LeftNumber != undefined && metricPosition.LeftNumber != null" class="font-size-14">
                            {{(metricPosition.MetricDetail?.DefaultMetricDirection == 0) ? "<" : ">"}}
                            {{getFormattedMetric(metricPosition.LeftNumber, metricPosition.MetricDetail?.ConversionType?.toString())}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

	<!-- Rewards Section -->
	<div class="container-fluid p-0">
		<div class="row">
			<div class="col-sm-12 pt-3">
				<span class="color-valyrianSteel font-size-14" cvLocalizedText langSection="Games" langKey="Reward_Breakdown">Reward Breakdown</span>
			</div>
		</div>

        <!--Multiplier Madness Rewards -->
        <div class="container p-0 mt-2" *ngIf="gameData.underlyingRule.GameType == 1">
            <div class="row">
                <div class="col-sm-12 pb-2 lato-bold font-size-12 colorMultiplierMadness">
                    {{rewards[0].coins}} Coins per {{metricValue && metricValue.MetricDetail?.Abbrev}}
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 pb-2 lato-bold font-size-12 colorMultiplierMadness">
                    {{rewards[0].xp}} XP per {{metricValue && metricValue.MetricDetail?.Abbrev}}
                </div>
            </div>
        </div>

        <!--Top Dog Rewards or Top Team Rewards-->
        <div class="pl-2 pr-2" *ngIf="gameData.underlyingRule.GameType == 2 || gameData.underlyingRule.GameType == 8">
            <div class="d-flex flex-column w-100">
                <div *ngFor="let TopDogReward of rewards; let index = index" class="pt-1">
                    <div>
                        <div class="d-flex pt-2">
                            <div class="d-flex">
							    <div *ngIf="index == 0" class="topDogRankIcon topDogRank1" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                                <div *ngIf="index == 1" class="topDogRankIcon topDogRank2" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                                <div *ngIf="index == 2" class="topDogRankIcon topDogRank3" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                                <div *ngIf="index == 3" class="topDogRankIcon topDogRank4" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                                <div *ngIf="index == 4" class="topDogRankIcon topDogRank5" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                            </div>
                            <div class="d-flex justify-content-between w-100">
                                <div class="d-flex align-items-center justify-content-between ml-2 px-3">
                                    {{TopDogReward.coins}}&nbsp;
                                    <span cvLocalizedText langSection="Games" langKey="Coins"></span>
                                </div>
							
                                <div class="d-flex align-items-center justify-content-between border-left px-3">
                                    {{TopDogReward.xp}}&nbsp;
                                    <span cvLocalizedText langSection="Games" langKey="XP"></span>
                                </div>

                                <div class="d-flex align-items-center justify-content-between border-left px-3">
								    <div *ngIf="!!TopDogReward.badges" class="d-flex align-items-center">
                                        <img [src]="'../Admin/ImageResizer.aspx?imgid='+TopDogReward.badges+'&w=24&h=24'" />
                                    </div>
								    <div *ngIf="!TopDogReward.badges">---</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		
        <!--Bullseye Rewards -->
        <div class="px-0" *ngIf="gameData.underlyingRule.GameType == 3">
            <div class="d-flex flex-column w-100">
                <div *ngFor="let bullseyeReward of rewards; let index = index" class="pt-2 pl-1">
                    <div>
                        <div class="d-flex pt-2">
                            <div class="d-flex">
							    <div *ngIf="index == 0" class="bullseyeTargetIcon tier1" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                                <div *ngIf="index == 1" class="bullseyeTargetIcon tier2" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                                <div *ngIf="index == 2" class="bullseyeTargetIcon tier3" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                                <div *ngIf="index == 3" class="bullseyeTargetIcon tier4" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                                <div *ngIf="index == 4" class="bullseyeTargetIcon tier5" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                            </div>
                            <div class="d-flex justify-content-between w-100">
                                <div class="d-flex align-items-center justify-content-between px-3">
                                    {{bullseyeReward.coins}}&nbsp;{{getLocalizedText("Coins", "Coins")}}
                                </div>
							
                                <div class="d-flex align-items-center justify-content-between border-left px-3">
                                    {{bullseyeReward.xp}}&nbsp;{{getLocalizedText("XP", "XP")}}
                                </div>

                                <div class="d-flex align-items-center justify-content-between border-left px-3">
								    <div *ngIf="!!bullseyeReward.badges" class="d-flex align-items-center">
                                        <img [src]="'../Admin/ImageResizer.aspx?imgid='+bullseyeReward.badges+'&w=24&h=24'" />
                                    </div>
								    <div *ngIf="!bullseyeReward.badges">---</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Connect3 -->
        <div class="pl-1 pr-1" *ngIf="gameData.underlyingRule.GameType == 6">
            <div class="container col-12">
                <div class="row">
                    <div class="d-flex flex-column w-100" style="border-top: 1px solid #D2D6DB;">
                        <div class="d-flex justify-content-between pt-2">
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(rewards[0] && rewards[0].coins)}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{rewards[0] && rewards[0].xp}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0 hide">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/currency.svg#currency"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.Connect3Rewards.ThreeInRow.currency != null ? gameData.Connect3Rewards.ThreeInRow.currency.rewardValue : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">
                                        <div *ngIf="rewards[0] && rewards[0].badges" class="d-flex align-items-center">
                                            <img [src]="'../Admin/ImageResizer.aspx?imgid='+rewards[0].badges+'&w=24&h=24'" class="img-fluid" />
                                        </div>
                                        <div *ngIf="!rewards[0] || !rewards[0].badges">---</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Blackout Game -->
        <div class="pl-1 pr-1" *ngIf="gameData.underlyingRule.GameType == 7">
            <div class="container col-12">
                <div class="row">
                    <div class="d-flex flex-column w-100" style="border-top: 1px solid #D2D6DB;">
                        <div class="d-flex justify-content-between pt-2">
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{rewards[0] && rewards[0].coins}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{rewards[0] && rewards[0].xp}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0 hide">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/currency.svg#currency"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.Connect3Rewards.Blackout.currency != null ? gameData.Connect3Rewards.Blackout.currency : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">
                                        <div *ngIf="rewards[0] && rewards[0].badges" class="d-flex align-items-center">
                                            <img [src]="'../Admin/ImageResizer.aspx?imgid='+rewards[0].badges+'&w=24&h=24'" class="img-fluid" />
                                        </div>
                                        <div *ngIf="!rewards[0] || !rewards[0].badges">---</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Milestone Rewards -->
        <div *ngIf="gameData.underlyingRule.GameType == 5">
            <div class="d-flex flex-column w-100">
                <div *ngFor="let milestoneReward of rewards; let index = index" class="pt-2 pl-1"> <!-- | orderBy:milestoneReward:reverse-->
                    <div>
                        <div class="d-flex pt-2">
                            <div class="d-flex">
                                <div class="tier1" [ngStyle]="getCheckmark(index)" style="width: 42px; height: 42px; display: block; background-size: 40px; background-repeat: no-repeat; background-position: center;"></div>
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex align-items-center justify-content-between ml-3 font-size-14 lato-bold  colorMilestone">Milestone {{index+1}}&nbsp;</div>
                                    <div [ngSwitch]="milestoneReward.metricTarget?.ComparerType" class="d-flex pl-2 align-items-center justify-content-between ml-3 font-size-14 lato-bold border-left">
                                        <span *ngSwitchCase="1" class="color-whaleTail font-size-12">{{( milestoneReward.metricTarget.LeftNumber != null ?  getLocalizedText("Greater_Than", "Greather Than") + " " + getFormattedMetric(milestoneReward.metricTarget.LeftNumber,  milestoneReward.metricTarget.MetricDetail.ConversionType?.toString()) : "")}}</span>
                                        <span *ngSwitchCase="2" class="color-whaleTail font-size-12">{{( milestoneReward.metricTarget.RightNumber != null ?  getLocalizedText("Less_Than", "Less Than") + " " + getFormattedMetric(milestoneReward.metricTarget.RightNumber, milestoneReward.metricTarget.MetricDetail.ConversionType?.toString()) : "")}}</span>
                                        <span *ngSwitchCase="3" class="color-whaleTail font-size-12">{{( milestoneReward.metricTarget.RightNumber != null ?  getLocalizedText("Between", "Between") + " " + getFormattedMetric(milestoneReward.metricTarget.LeftNumber, milestoneReward.metricTarget.MetricDetail.ConversionType?.toString()) + " " +  getLocalizedText("And", "And") + " " + getFormattedMetric(milestoneReward.metricTarget.RightNumber, milestoneReward.metricTarget.MetricDetail.ConversionType?.toString()) : "")}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between pt-2">
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{milestoneReward.coins}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{milestoneReward.xp}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0 hide">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/currency.svg#currency"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.MilestoneRewards[index].Currency != null ? gameData.MilestoneRewards[index].Currency.rewardValue : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">
                                        <div *ngIf="rewards[0] && rewards[0].badges" class="d-flex align-items-center">
                                            <img [src]="'../Admin/ImageResizer.aspx?imgid='+rewards[0].badges+'&w=24&h=24'" class="img-fluid" />
                                        </div>
                                        <div *ngIf="!rewards[0] || !rewards[0].badges">---</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Raffle Rewards -->
        <div *ngIf="gameData.underlyingRule.GameType == 9">
            <div class="d-flex flex-column w-100">
                <div class="raffle-rewards-details" *ngFor="let RaffleRewards of rewards; index as i">
                    <p class="w-25 text-break raffle-prize-details">{{getRank(i)}} Prize</p>
                    <p *ngIf="RaffleRewards.coins > 0" class="w-25 text-break raffle-prize-coins">{{RaffleRewards.coins}} Coins</p>
                    <p *ngIf="RaffleRewards.xp > 0" class="w-25 text-break raffle-prize-xp">{{RaffleRewards.xp}} XP</p>
                    <p *ngIf="RaffleRewards.customReward?.length > 0" class="text-break raffle-prize-custom">{{RaffleRewards.customReward}}</p>
                </div>
            </div>
        </div>

        <!-- Brackets Tournament -->
        <div *ngIf="gameData.underlyingRule.GameType == 10">
            <div class="container col-12">
                <div class="row" *ngFor="let BracketsTournamentRewards of rewards.reverse(); index as i">
                    <div class="d-flex flex-column w-100">
                        <div class="pt-2" [ngSwitch]="gameData.BracketsTournamentRewards.length - i">
                            <span *ngSwitchCase="1" class="colorBracketTournament font-size-14" cvLocalizedText langSection="Games" langKey="Round_1_Final">Final</span>
                            <span *ngSwitchCase="2" class="colorBracketTournament font-size-14" cvLocalizedText langSection="Games" langKey="Round_2_Semi_Finals">Semi Finals</span>
                            <span *ngSwitchCase="3" class="colorBracketTournament font-size-14" cvLocalizedText langSection="Games" langKey="Round_3_Quarter">Quarters</span>
                            <span *ngSwitchCase="4" class="colorBracketTournament font-size-14" cvLocalizedText langSection="Games" langKey="Round_4_Octaves">Octaves</span>
                        </div>

                        <div class="d-flex justify-content-between pt-1 ml-n2" *ngIf="BracketsTournamentRewards.coins > 0 || BracketsTournamentRewards.xp > 0 || BracketsTournamentRewards.badges > 0">
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{BracketsTournamentRewards.coins}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{BracketsTournamentRewards.xp}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">
                                        <div *ngIf="BracketsTournamentRewards.badges" class="d-flex align-items-center">
                                            <img [src]="'../Admin/ImageResizer.aspx?imgid='+BracketsTournamentRewards.badges+'&w=24&h=24'" class="img-fluid" />
                                        </div>
                                        <div *ngIf="!BracketsTournamentRewards.badges">---</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between pt-1" *ngIf="BracketsTournamentRewards.customReward?.length > 0">
                            <div class="col-12 pl-0">
                                <p *ngIf="BracketsTournamentRewards.customReward?.length > 0" class="text-break brackets-prize-custom mb-0">{{BracketsTournamentRewards.customReward}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #cxoneSummaryModal>
    <sol-modal [title]="game.gameTypeName"
               [basicButtonLabel]="getLocalizedCommonText('Close', 'Close')"
               (dismissed)="onDismiss()"
               (closed)="onClose()">
        <sol-modal-body>
            <!-- Header Game -->
            <div class="d-flex flex-row justify-content-start cxone-header-game">
                <div class="p-0 cxone-game-icon {{'cxone-' + game.iconClass}}"></div>
                <div class="d-flex flex-column cxone-game-title-container text-break">
                    <div class="cxone-game-title text-left">{{ gameName }}</div>
                </div>
            </div>

            <!-- Game Information -->
            <div class="d-flex justify-content-between flex-column">
                <div class="cxone-game-description pt-3 pb-3" [ngSwitch]="game.underlyingRule.GameType">
                    <span id="desc_MMCxone" *ngSwitchCase="1" cvLocalizedText langSection="Games_History" langKey="DescMM_Cxone">Commission style game; players rewarded per KPI unit achieved. *Should only be used for count-type metrics.</span>
                    <span id="desc_TDCxone" *ngSwitchCase="2" cvLocalizedText langSection="Games_History" langKey="DescTD">Players rewarded according to how they rank against other players.</span>
                    <span id="desc_BECxone" *ngSwitchCase="3" cvLocalizedText langSection="Games_History" langKey="DescBE">Players rewarded according to where they hit on the target (bullseye and rings).</span>
                    <span id="desc_C3Cxone" *ngSwitchCase="6" cvLocalizedText langSection="Games_History" langKey="DescC3">Earn reward by connecting 3 metrics in a row. Horizontal, vertical, or diagonal connections count.</span>
                    <span id="desc_BOCxone" *ngSwitchCase="7" cvLocalizedText langSection="Games_History" langKey="DescBO">Players earn the prize by completing the metric goal on every square.</span>
                    <span id="desc_TTCxone" *ngSwitchCase="8" cvLocalizedText langSection="Games_History" langKey="DescTT">"Teams" win rewards according to where they rank in comparison with other teams.</span>
                    <span id="desc_RRCxone" *ngSwitchCase="9" cvLocalizedText langSection="Games_History" langKey="DescRR">Prize(s) will be given out to a random qualified Participant.</span>
                </div>
            </div>

            <!-- Metric and Qualifier Information -->
            <div class="d-flex justify-content-between">
                <div class="cxone-borders pt-3 pb-3 w-100 d-flex border-top border-bottom flex-column">
                    <div class="d-flex flex-row color-valyrianSteel cxone-summary-titles">
                        <div [ngClass]="{ 'w-25': isValidQualifier, 'w-50' : !isValidQualifier }" *ngIf="!isConnectGame" class="mr-2">
                            <span cvLocalizedText langSection="Objectives" langKey="Metric">Metric:</span>
                            <div class="text-break" *ngIf="!isConnectGame"><span class="cxone-summary-values">{{ singleMetricName }}</span></div>
                        </div>
                        <div [ngClass]="{ 'w-25': isValidQualifier, 'w-50' : !isValidQualifier }" class="mr-2">
                            <span cvLocalizedText langSection="Rules_Engine" langKey="Qualifier">Qualifier</span><span>:</span>
                            <div class="text-break"><span class="cxone-summary-values">{{ qualifierName }}</span></div>
                        </div>
                        <div *ngIf="isValidQualifier" class="cxone-borders border-left pl-4 w-50" [ngSwitch]="game?.QualifierLevels?.comparerType">
                            <span *ngSwitchCase="1" class="cxone-game-description">{{getLocalizedText("Greater_Than", "Greather Than") + " " +  getFormattedMetric(game?.QualifierLevels?.leftNumber, game?.Qualifier?.conversionType?.toString())}}</span>
                            <span *ngSwitchCase="2" class="cxone-game-description">{{getLocalizedText("Less_Than", "Less Than") + " " + getFormattedMetric(game?.QualifierLevels?.leftNumber, game?.Qualifier?.conversionType?.toString())}}</span>
                            <span *ngSwitchCase="3" class="cxone-game-description">{{getLocalizedText("Between", "Between") + " " + getFormattedMetric(game?.QualifierLevels?.leftNumber, game?.Qualifier?.conversionType?.toString()) + " " + getLocalizedText("And", "And") + " " + getFormattedMetric(game?.QualifierLevels?.rightNumber, game?.Qualifier?.conversionType?.toString())}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Connect3/All - Display Metrics -->
            <div class="row p-3" *ngIf="isConnectGame" style="width: 75%; margin: 0 auto">
                <div class="col-4" *ngFor="let metricPosition of connect3Metrics | slice:0:9">
                    <div class="card mx-n2 my-2 text-center cxone-card-connect"
                         [ngClass]="getConnect3Class(metricPosition)" style="height:64px; width:64px">
                        <div class="d-flex flex-column justify-content-center align-items-center h-100">
                            <div class="metric-container" style="width: 3.75rem">
                                <svg class="icon-16" style="margin: 0 auto;" *ngIf="getCheck(metricPosition?.Position)">
                                    <use href="../../../App_Themes/CXone/icons/gamification/games/connect-3-check.svg#connect-3-check"></use>
                                </svg>
                                <div *ngIf="metricPosition === null"><svg class="icon-12 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg></div>
                                <div class="font-size-12 font-weight-600 cxone-metric-connect" [ngClass]="{ 'cxone-free-space': metricPosition.MetricID === -1, 'cxone-margin-checked': getCheck(metricPosition?.Position) }"
                                     #metricText [tooltip]="checkTextTruncation((metricPosition ===  null ? getLocalizedText('Metric_Goal', 'Metric Goal') : metricPosition.MetricID === -1 ? (getLocalizedText('Cxone_Free_Space', 'Free Space')) : (getLocalizedText(metricPosition.MetricDetail?.Abbrev.replace(' ', '_'), metricPosition.MetricDetail?.Abbrev))), metricText)" placement="top" container="body"
                                     (mouseenter)="tooltipValidation ? tooltip.show() : tooltip.hide()" containerClass="cxone-games-details-label-tooltip"
                                     triggers="manual" #tooltip="bs-tooltip" (mouseleave)="tooltip.hide()" (wheel)="tooltip.hide()">{{(metricPosition ===  null ? getLocalizedText("Metric_Goal", "Metric Goal") : metricPosition.MetricID === -1 ? (getLocalizedText("Cxone_Free_Space", "Free Space")) : (getLocalizedText(metricPosition.MetricDetail?.Abbrev.replace(" ", "_"), metricPosition.MetricDetail?.Abbrev)))}}</div>
                                <div *ngIf="metricPosition.LeftNumber != undefined && metricPosition.LeftNumber != null" class="font-size-11 cxone-metric-connect" [ngClass]="{ 'cxone-margin-checked': getCheck(metricPosition?.Position) }">
                                    {{(metricPosition.MetricDetail?.DefaultMetricDirection == 0) ? "<" : ">"}}
                                    {{getFormattedMetric(metricPosition.LeftNumber, metricPosition.MetricDetail?.ConversionType?.toString())}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Rewards Section -->
            <div class="d-flex flex-column p-0" [ngClass]="{ 'cxone-borders border-top': (gameData.underlyingRule.GameType == 6 || gameData.underlyingRule.GameType == 7) }">
                <div class="row">
                    <div class="col-12 space-card-14 cxone-summary-titles">
                        <span cvLocalizedText langSection="Games" langKey="Reward_Breakdown">Reward Breakdown</span>
                    </div>
                </div>

                <!--Multiplier Madness Rewards -->
                <div class="row p-0" *ngIf="gameData.underlyingRule.GameType == 1">
                    <div class="col-12 mt-3 mb-1 cxone-game-description">
                        {{(rewards[0].coins) + " " + (rewards[0].coins ===  1 ? getLocalizedText("Coin_Per_MM", "Coin per") : getLocalizedText("Coins_Per_MM", "Coins per")) + " " + (singleMetricName)}}
                    </div>
                </div>

                <!--Top Dog / Top Team Rewards-->
                <div *ngIf="gameData.underlyingRule.GameType == 2 || gameData.underlyingRule.GameType == 8">
                    <div class="d-flex flex-column w-100 pt-1">
                        <div *ngFor="let TopDogReward of rewards; let index = index">
                            <div class="d-flex" [ngClass]="{ 'pt-2': index === 0, 'pt-3' : index !== 0 }">
                                <div class="d-flex w-25">
                                    <div *ngIf="index === 0">
                                        <svg class="icon-24 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/rank.svg#rank"></use>
                                        </svg>
                                        <span class="rank-text">1</span>
                                    </div>
                                    <div *ngIf="index === 1">
                                        <svg class="icon-24 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/rank.svg#rank"></use>
                                        </svg>
                                        <span class="rank-text">2</span>
                                    </div>
                                    <div *ngIf="index === 2">
                                        <svg class="icon-24 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/rank.svg#rank"></use>
                                        </svg>
                                        <span class="rank-text">3</span>
                                    </div>
                                    <div *ngIf="index === 3">
                                        <svg class="icon-24 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/rank.svg#rank"></use>
                                        </svg>
                                        <span class="rank-text">4</span>
                                    </div>
                                    <div *ngIf="index === 4">
                                        <svg class="icon-24 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/rank.svg#rank"></use>
                                        </svg>
                                        <span class="rank-text">5</span>
                                    </div>
                                </div>
                                <div class="w-25">
                                    <span class="pr-2">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                                        </svg>
                                    </span>
                                    <span class="cxone-summary-titles mr-3">{{TopDogReward.coins}}</span>
                                </div>
                                <div class="w-25">
                                    <span class="pr-2">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                                        </svg>
                                    </span>
                                    <div *ngIf="!!TopDogReward.badges" class="d-inline">
                                        <img [src]="'../Admin/ImageResizer.aspx?imgid='+TopDogReward.badges+'&w=24&h=24'" />
                                    </div>
                                    <div *ngIf="!TopDogReward.badges" class="d-inline">
                                        ---
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Bullseye Rewards -->
                <div *ngIf="gameData.underlyingRule.GameType == 3">
                    <div class="d-flex flex-column w-100 pt-1">
                        <div *ngFor="let bullseyeReward of rewards; let index = index">
                            <div class="d-flex" [ngClass]="{ 'pt-2': index === 0, 'pt-3' : index !== 0 }">
                                <div class="d-flex w-25">
                                    <div class="bullseye-container" *ngIf="index == 0">
                                        <div *ngFor="let ring of bullseyeRings; let i = index; let total = count">
                                            <div class="bullseye circle-bullseye" [ngClass]="{'circle-marked': i === 4}" [ngStyle]="getRingStyle(i, total)"></div>
                                        </div>
                                    </div>
                                    <div class="bullseye-container" *ngIf="index == 1">
                                        <div *ngFor="let ring of bullseyeRings; let i = index; let total = count">
                                            <div class="bullseye circle-bullseye" [ngClass]="{'circle-marked': i === 3}" [ngStyle]="getRingStyle(i, total)"></div>
                                        </div>
                                    </div>
                                    <div class="bullseye-container" *ngIf="index == 2">
                                        <div *ngFor="let ring of bullseyeRings; let i = index; let total = count">
                                            <div class="bullseye circle-bullseye" [ngClass]="{'circle-marked': i === 2}" [ngStyle]="getRingStyle(i, total)"></div>
                                        </div>
                                    </div>
                                    <div class="bullseye-container" *ngIf="index == 3">
                                        <div *ngFor="let ring of bullseyeRings; let i = index; let total = count">
                                            <div class="bullseye circle-bullseye" [ngClass]="{'circle-marked': i === 1}" [ngStyle]="getRingStyle(i, total)"></div>
                                        </div>
                                    </div>
                                    <div class="bullseye-container" *ngIf="index == 4">
                                        <div *ngFor="let ring of bullseyeRings; let i = index; let total = count">
                                            <div class="bullseye circle-bullseye" [ngClass]="{'circle-marked': i === 0}" [ngStyle]="getRingStyle(i, total)"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-25">
                                    <span class="pr-2">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                                        </svg>
                                    </span>
                                    <span class="cxone-summary-titles mr-3">{{bullseyeReward.coins}}</span>
                                </div>
                                <div class="w-25">
                                    <span class="pr-2">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                                        </svg>
                                    </span>
                                    <div *ngIf="!!bullseyeReward.badges" class="d-inline">
                                        <img [src]="'../Admin/ImageResizer.aspx?imgid='+bullseyeReward.badges+'&w=24&h=24'" />
                                    </div>
                                    <div *ngIf="!bullseyeReward.badges" class="d-inline">
                                        ---
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Connect3/All Rewards -->
                <div *ngIf="gameData.underlyingRule.GameType == 6 || gameData.underlyingRule.GameType == 7">
                    <div class="d-flex flex-column w-100 pt-1">
                        <div class="d-flex pt-2">
                            <div class="w-25">
                                <span class="pr-2">
                                    <svg class="icon-16 fill-valyrianSteel">
                                        <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                                    </svg>
                                </span>
                                <span class="cxone-summary-titles mr-3">{{(rewards[0] && rewards[0].coins)}}</span>
                            </div>
                            <div class="w-25">
                                <span class="pr-2">
                                    <svg class="icon-16 fill-valyrianSteel">
                                        <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                                    </svg>
                                </span>
                                <div *ngIf="rewards[0] && rewards[0].badges" class="d-inline">
                                    <img [src]="'../Admin/ImageResizer.aspx?imgid='+rewards[0].badges+'&w=24&h=24'" />
                                </div>
                                <div *ngIf="!rewards[0] || !rewards[0].badges" class="d-inline">
                                    ---
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Milestone Rewards -->
                <div *ngIf="gameData.underlyingRule.GameType == 5">
                    <div class="d-flex flex-column w-100 pt-1">
                        <div *ngFor="let milestoneReward of rewards; let index = index">
                            <div class="d-flex" [ngClass]="{ 'pt-2': index === 0, 'pt-3' : index !== 0 }">
                                <div class="d-flex w-25">
                                    <div class="tier1" [ngStyle]="getCheckmark(index)" style="width: 24px; height: 24px; display: block; background-size: 22px; background-repeat: no-repeat; background-position: center;"></div>
                                </div>
                                <div class="w-25">
                                    <span class="pr-2">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                                        </svg>
                                    </span>
                                    <span class="cxone-summary-titles mr-3">{{milestoneReward.coins}}</span>
                                </div>
                                <div class="w-25">
                                    <span class="pr-2">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                                        </svg>
                                    </span>
                                    <div *ngIf="rewards[0] && rewards[0].badges" class="d-inline">
                                        <img [src]="'../Admin/ImageResizer.aspx?imgid='+rewards[0].badges+'&w=24&h=24'" />
                                    </div>
                                    <div *ngIf="!rewards[0] || !rewards[0].badges" class="d-inline">
                                        ---
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TODO Raffle and Brackets Tournament Rewards -->
            </div>
        </sol-modal-body>
    </sol-modal>
</ng-template>
